import { BarChart3, CreditCard, LogOut, Mail, PackageCheck, ShoppingCart, UserRound, Boxes, Target, TrendingUp } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { clearAdminToken, getAdminToken } from "../api";
import { LoginPage } from "./LoginPage";

const links = [
  { to: "/", label: "Dashboard", icon: BarChart3 },
  { to: "/checkouts", label: "Checkouts", icon: ShoppingCart },
  { to: "/products", label: "Produtos", icon: Boxes },
  { to: "/customers", label: "Clientes", icon: UserRound },
  { to: "/payments", label: "Pagamentos", icon: CreditCard },
  { to: "/orders", label: "Pedidos", icon: PackageCheck },
  { to: "/tracking", label: "Pixel & Tracking", icon: Target },
  { to: "/analytics", label: "Inteligência", icon: TrendingUp },
  { to: "/settings", label: "Emails", icon: Mail }
];

export function AdminLayout() {
  const [authenticated, setAuthenticated] = useState(Boolean(getAdminToken()));

  if (!authenticated) return <LoginPage onLogin={() => setAuthenticated(true)} />;

  return (
    <main className="min-h-screen bg-soft">
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3">
          <div>
            <p className="text-xs uppercase tracking-normal text-slate-500">MelHot Checkout</p>
            <h1 className="text-lg font-semibold text-ink">Painel Admin</h1>
          </div>
          <button
            className="inline-flex items-center gap-2 rounded-md border border-line px-3 py-2 text-sm font-semibold"
            onClick={() => {
              clearAdminToken();
              setAuthenticated(false);
            }}
          >
            <LogOut size={16} /> Sair
          </button>
        </div>
      </header>
      <div className="mx-auto grid max-w-7xl gap-5 px-4 py-5 lg:grid-cols-[220px_minmax(0,1fr)]">
        <nav className="flex gap-2 overflow-auto lg:block lg:space-y-2">
          {links.map((link) => {
            const Icon = link.icon;
            return (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `flex min-w-fit items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold ${
                    isActive ? "bg-ink text-white" : "bg-white text-slate-700"
                  }`
                }
              >
                <Icon size={16} /> {link.label}
              </NavLink>
            );
          })}
        </nav>
        <section>
          <Outlet />
        </section>
      </div>
    </main>
  );
}
